import { auth } from '../firebase/firebaseConfig';
import { signOut } from 'firebase/auth';
import { useLocation, useNavigate } from 'react-router-dom';
import Logo from './Logo';
import { theme } from '../utils/theme';
import { useAuth } from '../contexts/AuthContext';
import { useEnquiriesCount } from '../hooks/useEnquiriesCount';
import useJobsCount from '../hooks/useJobsCount';


const ShopNavBar = ({ type = "printShop" }) => {
    const { currentUser } = useAuth();
    const { count: unreadJobsCount, jobCountLoading: jobsLoading } = useJobsCount();
    const { unreadEnquiriesCount, loading: enquiriesLoading } = useEnquiriesCount();
    const navigate = useNavigate();
    const location = useLocation();
    const isSettings = location.pathname === '/shop/settings';

    let t;
    if (type === "admin") {
        t = theme.printShop;
    } else {
        t = theme[type];
    }

    const navigation = [];

    if (currentUser?.type === "printShop") {
        navigation.push(
            {
                name: 'Home',
                href: '/shop/dashboard',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="w-[16px] h-[16px]">
                        <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                        <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    </svg>
                )
            },
            {
                name: 'Enquiries',
                href: '/supplier/enquiries',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-mail w-[16px] h-[16px]">
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                )
            },
            {
                name: 'Analytics',
                href: '/shop/analytics',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="w-[16px] h-[16px]">
                        <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                        <path d="M18 17V9" />
                        <path d="M13 17V5" />
                        <path d="M8 17v-3" />
                    </svg>
                )
            },
            {
                name: 'Past Jobs',
                href: '/shop/closed-jobs',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="w-[16px] h-[16px]">
                        <rect width="20" height="5" x="2" y="3" rx="1" />
                        <path d="M4 8v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8" />
                        <path d="M10 12h4" />
                    </svg>
                )
            }
        );
    }

    if (currentUser?.type === "supplier") {
        navigation.push(
            {
                name: 'Overview',
                href: '/supplier/dashboard',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="w-[16px] h-[16px]">
                        <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                        <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    </svg>
                )
            },
            {
                name: 'Enquiries',
                href: '/supplier/enquiries',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-mail w-[16px] h-[16px]">
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                )
            }
        );
    }

    if (currentUser?.type === "specialist") {
        navigation.push(
            {
                name: 'Overview',
                href: '/supplier/dashboard',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                        className="w-[16px] h-[16px]">
                        <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
                        <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                    </svg>
                )
            },
            {
                name: 'Enquiries',
                href: '/supplier/enquiries',
                icon: (
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-mail w-[16px] h-[16px]">
                        <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                        <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                    </svg>
                )
            }
        );
    }

    const handleSettingClick = () => {
        if (currentUser?.type !== "admin") {
            navigate('/shop/settings');
        }
    };

    const handleLogout = async () => {
        await signOut(auth);
        navigate('/shop-login', { replace: true });
    };

    return (
        <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
            <nav className="max-w-[1200px] mx-auto px-4 md:px-8 py-3 flex items-center justify-between">

                {/* LOGO */}
                <Logo href={type === "admin" ? "/admin/dashboard" : "/shop/dashboard"} />

                {/* NAV */}
                <div className="hidden lg:flex items-center gap-1 bg-gray-100 rounded-xl p-1">
                    {navigation.map((item) => {
                        const isActive = location.pathname === item.href;

                        return (
                            <button
                                key={item.name}
                                onClick={() => navigate(item.href)}
                                className={`flex items-center gap-[6px] px-[16px] py-[8px] rounded-[10px] font-semibold text-[13px] transition-all
                                ${isActive ? 'bg-white text-[#212326] shadow' : 'text-gray-500 hover:text-gray-900'}`}
                            >
                                {item.icon}
                                {item.name}

                                {item.name === "Home" &&
                                    !jobsLoading &&
                                    unreadJobsCount > 0 && (
                                        <span
                                            className="ml-[4px] min-w-[18px] h-[18px] rounded-full text-white text-[10px] font-semibold flex items-center justify-center px-[5px]"
                                            style={{ backgroundColor: t.primary }}
                                        >
                                            {unreadJobsCount}
                                        </span>
                                    )}

                                {item.name === 'Enquiries' && (
                                    !enquiriesLoading &&
                                    unreadEnquiriesCount > 0 &&
                                    <span
                                        className="ml-[4px] min-w-[18px] h-[18px] rounded-full text-white text-[10px] font-semibold flex items-center justify-center px-[5px]"
                                        style={{ backgroundColor: t.primary }}
                                    >
                                        {unreadEnquiriesCount}
                                    </span>
                                )}
                            </button>
                        );
                    })}
                </div>

                {/* RIGHT */}
                <div className="flex items-center gap-3">

                    {/* NOTIFICATIONS */}
                    {/* <button className="relative w-[36px] h-[36px] rounded-[10px] hover:bg-[#f4f5f6] flex items-center justify-center transition-colors">
                        <svg className="w-[18px] h-[18px] text-[#717182]" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path d="M10.268 21a2 2 0 0 0 3.464 0" />
                            <path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326" />
                        </svg>

                        <div
                            className="absolute top-[6px] right-[6px] w-[8px] h-[8px] rounded-full border-[2px] border-white"
                            style={{ backgroundColor: t.primary }}
                        />
                    </button> */}

                    {/* PROFILE */}
                    <button
                        onClick={handleSettingClick}
                        className={`hidden sm:flex items-center gap-[10px] pl-[12px] border-l border-[#e4e5e7] rounded-[10px] pr-[10px] py-[4px]
                        hover:bg-[#f4f5f6] transition-colors ${isSettings ? `bg-[${t.bg}]` : ''}`}
                    >
                        <div
                            className="w-[34px] h-[34px] rounded-[10px] flex items-center justify-center"
                            style={{ backgroundColor: t.primary }}
                        >
                            <span className="font-semibold text-[13px] text-white">
                                {currentUser?.shopName?.charAt(0) || 'P'}
                            </span>
                        </div>

                        <div className="flex flex-col text-left">
                            <span className="font-medium text-[13px] text-[#212326] truncate max-w-[120px]">
                                {currentUser?.shopName || "Print Shop"}
                            </span>
                            <span className="font-medium text-[11px] text-[#9298a0] truncate max-w-[120px]">
                                {currentUser?.email || ""}
                            </span>
                        </div>

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            className={`lucide lucide-settings w-[14px] h-[14px] ml-[2px] transition-colors ${isSettings ? `text-[${t.primary}]` : 'text-[#c0c2c6]'}`}>
                            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z">
                            </path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                    </button>

                    <button
                        onClick={() => currentUser?.type !== "admin" && handleSettingClick()}
                        className={`sm:hidden w-[36px] h-[36px] rounded-[10px] flex items-center justify-center
                         transition-colors hover:bg-[#f4f5f6] text-[#717182] ${isSettings ? `bg-[${t.bg}]` : ''}`}
                        title="Profile &amp; Settings"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className={`lucide lucide-settings w-[18px] h-[18px] ${isSettings ? `text-[${t.primary}]` : ''}`}>
                            <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
                            <circle cx="12" cy="12" r="3"></circle>
                        </svg>
                    </button>

                    {/* LOGOUT */}
                    <button
                        onClick={handleLogout}
                        className="px-3 py-2 rounded-xl hover:bg-gray-100 text-gray-500 hover:text-gray-900"
                    >
                        <svg className="w-[16px] h-[16px]" xmlns="http://www.w3.org/2000/svg"
                            fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                            <polyline points="16 17 21 12 16 7" />
                            <line x1="21" x2="9" y1="12" y2="12" />
                        </svg>
                    </button>

                </div>

            </nav>
        </header>
    );
};

export default ShopNavBar;